var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_5555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83323 3.26376C5.22836 2.99974 5.64574 2.77516 6.07933 2.59184C7.13151 2.14699 7.6576 1.92456 8.3288 2.36951C9 2.81446 9 3.5429 9 4.99978V6.49978C9 7.914 9 8.6211 9.43934 9.06044C9.87868 9.49978 10.5858 9.49978 12 9.49978H13.5C14.9569 9.49978 15.6853 9.49978 16.1303 10.171C16.5752 10.8422 16.3528 11.3683 15.9079 12.4205C15.7246 12.854 15.5 13.2714 15.236 13.6666C14.4119 14.8999 13.2406 15.8612 11.8701 16.4289C10.4997 16.9965 8.99168 17.1451 7.53682 16.8557C6.08197 16.5663 4.7456 15.852 3.6967 14.8031C2.64781 13.7542 1.9335 12.4178 1.64411 10.963C1.35472 9.5081 1.50325 8.0001 2.07091 6.62966C2.63856 5.25921 3.59986 4.08787 4.83323 3.26376Z",
    stroke: "#8C8C90",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.875 2.23633C13.5105 2.91466 15.5854 4.98953 16.2637 7.62505",
    stroke: "#8C8C90",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_5555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/Monitoring.09b24d3f5c459d98c5da2e0d3b67a523.svg";
export { ForwardRef as ReactComponent };